'use strict';

/* eslint consistent-this: [2, "self", "favoriteList", "watchedList"] */

var Page = require('stb-component-page'),
    dom  = require('spa-dom'),
    keys = require('stb-keys'),

    Layout = require('mag-component-layout'),
    app    = require('mag-app'),

    MainPanel = require('../components/main.panel'),

    utils = {
        prepareMainMovies: require('../utils/prepare.main.movies'),
        prepareMovieData: require('../utils/prepare.movie.data'),
        toggleFavorite: require('../utils/toggle.favorite')
    },
    InfoPanel         = require('../components/info.panel'),
    itemListRender    = require('../renders/item.list'),

    timers = {},
    page   = new Page({$node: document.getElementById('pageMain')}),

    infoPanel, searchLayout, searchValue,
    mainPanel, cacheData,
    favoriteList, watchedList,
    leftLayout, f3;


/**
 * Click on item.
 *
 * @param {Object} event - event
 *
 * @this mainPanel
 */
function clickItem ( event ) {
    var line = {},
        value = event.$item.value;

    if ( value ) {
        if ( (value.censored || (value.category && value.category.censored)) && !core.accessControl.state ) {
            core.accessControl.request(function ( error ) {
                if ( !error ) {
                    app.route(app.pages.info, {info: value, type: 'main'});
                }
            });
        } else {
            app.route(app.pages.info, {info: value, type: 'main'});
        }
    } else {
        line = mainPanel.data[mainPanel.focusLine.index];
        app.route(app.pages.movies, line);
    }
}


/**
 * Focus to the list function.
 *
 * @this mainPanel
 */
function focusList () {
    this.emit('focus:item', {$prev: null, $curr: this.$focusItem});
}


/**
 * Focus on item.
 *
 * @param {Object} event - focus item event
 *
 * @this mainPanel.mainList
 */
function focusItem ( event ) {
    clearTimeout(timers.info);
    timers.info = setTimeout(function () {
        // var screenshots;

        if ( event.$curr ) {
            if ( event.$curr.value ) {
                infoPanel.showMovie();
                infoPanel.fillMovie(event.$curr.data.value);
            } else {
                infoPanel.showSeeMore();
                // infoPanel.$info.innerText = _('See more');
            }
        }
    }, core.environment.onFocusDebounceTimeout);
}


/**
 * Get items for line ( grid list ).
 *
 * @this mainPanel.mainList
 *
 * @param {Function} callback - result handler
 */
function getItems ( callback ) {
    var config = {},
        self = this;

    //TODO after fill event for check unique lists
    if ( this.query ) {
        Object.keys(this.query).forEach(function ( key ) {
            if ( self.query[key] ) {
                config[key] = self.query[key];
            }
        });
        if ( this.query.favorite ) {
            favoriteList = this;
        }

        if ( this.query['not_ended'] ) {
            watchedList = this;
        }
    }

    if ( DEVELOP ) {
        window.favoriteList = favoriteList;
        window.watchedList = watchedList;
    }

    config.limit = app.metrics.grid.lineCount + app.metrics.grid.lineCache + 1;
    app.api.getList(config, function ( error, data ) {
        if ( error ) {
            callback([]);
        } else {
            callback(utils.prepareMainMovies(data, self.title));
        }
    });
}


/**
 * Change favorite state.
 */
function toggleFavorite () {
    var video = mainPanel.focusLine.$focusItem.value;

    if ( video.favorite ) {
        infoPanel.$movie.classList.remove('inFavorite');
    } else {
        infoPanel.$movie.classList.add('inFavorite');
    }
    utils.toggleFavorite(video);
}


/**
 * Prepare sections data to use in grid list.
 *
 * @this mainPanel.mainList
 *
 * @param {Object} data - sections config ( answer from server )
 */
function initMainGrid ( data ) {
    var config = {
            data: [],
            focusIndex: 0
        },
        index;

    data = data.data;

    cacheData = data.slice();
    for ( index = 0; index < data.length; index++ ) {
        data[index].query.search = searchValue;
        config.data.push({
            events: {
                'focus:item': focusItem,
                'click:item': clickItem,
                focus: focusList
            },
            title: data[index].name,
            getter: getItems,
            size: app.metrics.grid.lineSize,
            bufferSize: app.metrics.grid.lineCache,
            query: data[index].query,
            hasEmptyItems: true,
            render: itemListRender,
            cycle: true,
            focusIndex: 0
        });
    }

    mainPanel.setData(config);
}


infoPanel = new InfoPanel();

if ( TARGET === 'android-stb' || TARGET === 'android-app' ) {
    f3 = new Layout({
        focusable: true,
        data: [
            {
                className: 'favoriteTitle add',
                value: gettext('Hold the OK button to add to Favorites')
            },
            {
                className: 'favoriteTitle remove',
                value: gettext('Hold the OK button to remove from Favorites')
            }
        ],
        className: 'favoriteBlock',
        events: {
            click: toggleFavorite
        }
    });
} else {
    f3 = new Layout({
        focusable: true,
        data: [
            {
                className: 'theme-icon theme-icon-rc-f3'
            },
            {
                className: 'favoriteTitle add',
                value: gettext('Add to favorites')
            },
            {
                className: 'favoriteTitle remove',
                value: gettext('Remove from favorites')
            }
        ],
        className: 'favoriteBlock',
        events: {
            click: toggleFavorite
        }
    });
}
infoPanel.$movie.appendChild(f3.$node);


searchLayout = new Layout({
    data: [
        dom.tag('div', {className: 'searchFocus'}, dom.tag('div', {className: 'searchIcon'})),
        {
            name: '$text',
            value: gettext('Search for movies, series and TV shows'),
            className: 'searchText noData'
        }
    ],
    className: 'searchBlock',
    events: {
        focus: function () {
            infoPanel.showInfo();
            infoPanel.$info.innerText = gettext('Find your favorite movies, series and TV shows by title or by genre');
        },
        click: function () {
            core.intent({
                action: 'keyboard',
                data: {
                    value: searchValue || '',
                    title: gettext('Search for movies, series and TV shows')
                },
                events: {
                    done: function ( data ) {
                        if ( data.value ) {
                            searchLayout.$body.classList.add('searchActive');
                            searchLayout.links.$text.innerText = data.value;
                            searchLayout.links.$text.classList.remove('noData');
                            searchValue = data.value;
                        } else {
                            searchLayout.$body.classList.remove('searchActive');
                            searchLayout.links.$text.innerText = gettext('Search for movies, series and TV shows');
                            searchLayout.links.$text.classList.add('noData');
                            searchValue = '';
                        }
                        //TODO rename cacheData to sectionList
                        initMainGrid({data: cacheData});
                    }
                }
            }, function ( error ) {
                debug.fail('Keyboard error', error);
            });
            event.stop = true;
        },
        keydown: function ( event ) {
            switch ( event.code ) {
                case keys.down:
                    mainPanel.focus();
                    event.stop = true;
                    break;
                case keys.enter:
                    // there are some listeners
                    if ( this.events['click'] ) {
                        // notify listeners
                        this.emit('click');
                    }
                    event.stop = true;
                    break;
            }
        }
    }
});


mainPanel = new MainPanel({
    events: {
        focus: function () {
            if ( mainPanel.data.length ) {
                infoPanel.showInfo();
            } else {
                searchLayout.focus();
            }

        },
        'focus:line': function ( event ) {
            if ( event.$curr.index === 0 ) {
                searchLayout.show();
            } else if ( event.$curr.index === 1 ) {
                searchLayout.hide();
            }
        },
        overflow: function ( data ) {
            if ( data.direction === keys.up ) {
                searchLayout.focus();
            }
        },
        keydown: function ( event ) {
            switch ( event.code ) {
                case keys.f3:
                    toggleFavorite();
                    event.stop = true;
                    break;
                default:
                    MainPanel.prototype.defaultEvents.keydown.call(this, event);
                    break;
            }
        }
    },
    size: 3,
    bufferSize: 3,
    focusPosition: 1,
    emptyItems: true,
    className: 'mainPanel',
    noData: gettext('No results found.')
});


mainPanel.addListener('data:load', function () {
    if ( mainPanel.data.length ) {
        mainPanel.focus();
    }

    app.ready();
});


leftLayout = new Layout({
    focusable: false,
    data: [searchLayout, mainPanel],
    className: 'mainPanel'
});


leftLayout.$node.appendChild(dom.tag('div', {className: 'shadow'}));

page.add(leftLayout);
page.add(infoPanel.layout);


page.once('show', function () {
    app.api.getSections(function ( error, data ) {
        if ( !error ) {
            initMainGrid(data);
        }
    });

    infoPanel.clearRating();
});


page.addListeners({
    keydown: function ( event ) {
        switch ( event.code ) {
            case keys.back:
                if ( searchValue ) {
                    searchLayout.$body.classList.remove('searchActive');
                    searchLayout.links.$text.innerText = gettext('Search for movies, series and TV shows');
                    searchLayout.links.$text.classList.add('noData');
                    searchValue = '';
                    initMainGrid({data: cacheData});
                } else {
                    app.exit();
                }
                break;
        }
    },
    'change:watched': function ( data ) {
        function checkStatus ( movie ) {
            if ( movie.value.id === data.id ) {
                movie.value['watched_time'] = data['watched_time'];
                movie.value['watched_status'] = data['watched_status'];
                movie.value['last_watched_file_id'] = data['last_watched_file_id'];
            }
        }

        if ( watchedList.listLink && watchedList.listLink.data.length ) {
            watchedList.listLink.refreshData();
        } else {
            watchedList.getter(function ( listData ) {
                watchedList.data = listData;
                if ( watchedList.data.length ) {
                    if ( mainPanel.data.indexOf(watchedList) === -1 ) {
                        mainPanel.insert(
                            watchedList,
                            mainPanel.data.indexOf(favoriteList) === -1 ? mainPanel.data.length : mainPanel.data.length - 1
                        );
                    }
                } else if ( mainPanel.data.indexOf(watchedList) !== -1 ) {
                    mainPanel.removeItem(watchedList);
                }
            });
        }

        // change state video in other category
        mainPanel.data.forEach(function ( line ) {
            line.data.forEach(checkStatus);
        });
    }
});


app.addListener('change:favorite', function ( data ) {
    var video = data.video;

    function checkStatus ( movie ) {
        if ( movie.value.id === video.id && movie.value.favorite !== video.favorite ) {
            movie.value.favorite = video.favorite;
        }
    }

    if ( video === mainPanel.focusLine.$focusItem.value ) {
        if ( video.favorite ) {
            infoPanel.$movie.classList.add('inFavorite');
        } else {
            infoPanel.$movie.classList.remove('inFavorite');
        }
    }

    if ( data.error ) {
        return;
    }

    if ( favoriteList.listLink && favoriteList.listLink.data.length ) {
        favoriteList.listLink.refreshData();
    } else {
        favoriteList.getter(function ( listData ) {
            favoriteList.data = listData;
            if ( favoriteList.data.length ) {
                if ( mainPanel.data.indexOf(favoriteList) === -1 ) {
                    mainPanel.insert(favoriteList, mainPanel.data.length);
                }
            } else if ( mainPanel.data.indexOf(favoriteList) !== -1 ) {
                mainPanel.removeItem(favoriteList);
            }
        });
    }

    // change state video in other category
    mainPanel.data.forEach(function ( line ) {
        line.data.forEach(checkStatus);
    });
});


if ( DEVELOP ) {
    window.mainPanel = mainPanel;
    window.searchLayout = searchLayout;
}


core.addListener('intent', function ( intent, callback ) {
    if ( intent.action === 'videoClub' ) {
        switch ( intent.mime ) {
            case 'info':
                if ( intent.data ) {
                    if ( app.pages.info === app.activePage ) {
                        app.pages.info.emit('show', {
                            data: {
                                info: intent.data.prepared ? intent.data : utils.prepareMovieData(intent.data),
                                type: 'intent',
                                callback: callback
                            }
                        });
                    } else {
                        app.route(app.pages.info, {
                            info: intent.data.prepared ? intent.data : utils.prepareMovieData(intent.data),
                            type: 'intent',
                            callback: callback
                        });
                    }
                    callback(false);
                } else {
                    callback(true);
                }

                break;

            default:
                app.route(app.pages.main);
                callback(false);
                break;
        }
    }
});


module.exports = page;
